import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	selectedOption: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	selectedOptionWithSearch: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	selectedOption: {
		id: 'command-palette.modal.modal-content.screen-reader-content.selected-option',
		defaultMessage: '{selectedOptionLabel}, selected, ({selectedIndex} of {totalSuggestions})',
		description:
			'Message for screen readers to read out when an option is selected in the command palette. {selectedOptionLabel} is the name of the selected option, {selectedIndex} is the index of the selected option, {totalSuggestions} is the total number of suggestions.',
	},
	selectedOptionWithSearch: {
		id: 'command-palette.modal.modal-content.screen-reader-content.selected-option-with-search',
		defaultMessage:
			'{selectedOptionLabel}, selected, ({selectedIndex} of {totalSuggestions}) for {search}',
		description:
			'Message for screen readers to read out when an option is selected in the command palette. {selectedOptionLabel} is the name of the selected option, {selectedIndex} is the index of the selected option, {totalSuggestions} is the total number of suggestions.',
	},
});
export default messages;
